module.exports = __webpack_public_path__ + "img/logo-green.6f775f6d.svg";